module.exports = __webpack_public_path__ + "static/internet-3bfd86ea265b756b2a8df89c4c6bc561.svg";